import { JUNCTURES_LIST } from '../../constants';

const initialState = {
  data: [],
  loading: true,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case JUNCTURES_LIST.LOAD:
      return {
        ...state,
        loading: true,
      };
    case JUNCTURES_LIST.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case JUNCTURES_LIST.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
